import {NgModule} from '@angular/core';
import {EmailValidator} from './emailValidator.directive';
import {IziviaSlideDirective} from './iziviaSlide/iziviaSlide.directive';
import {IziviaSlideTemplateDirective} from './iziviaSlide/iziviaSlideTemplate.directive';

const DIRECTIVES = [
    EmailValidator,
    IziviaSlideDirective,
    IziviaSlideTemplateDirective
];

@NgModule({
    declarations: DIRECTIVES,
    exports: DIRECTIVES
})
export class FrontDirectivesModule {

}
